'use strict';

var React = require('react');
var ReactPaginate = require('react-paginate');
var functions = require('../../helpers/functions.js');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
var paginator_styles = require('./paginator.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var ReactPaginate__default = /*#__PURE__*/_interopDefaultCompat(ReactPaginate);

const Paginator = ({ page, itemsTotal, onPageChange, itemsPerPage, scrollPosition, }) => {
    const handlePageChange = React.useCallback(({ selected }) => {
        onPageChange(selected, itemsPerPage);
        window.scrollTo(0, scrollPosition);
    }, [onPageChange, itemsPerPage, scrollPosition]);
    if (itemsTotal <= itemsPerPage) {
        return null;
    }
    return (React__default.default.createElement(paginator_styles.PaginatorContainerStyled, { id: "paginator" },
        React__default.default.createElement(ReactPaginate__default.default, { pageCount: Math.ceil(itemsTotal / itemsPerPage), pageRangeDisplayed: 5, forcePage: page, marginPagesDisplayed: 1, onPageChange: handlePageChange, disableInitialCallback: true, previousLabel: React__default.default.createElement(component.Icon, { name: "back-filled", size: "m" }), nextLabel: React__default.default.createElement(component.Icon, { name: "next-filled", size: "m" }), breakLabel: "...", containerClassName: paginator_styles.containerClassName, pageLinkClassName: paginator_styles.pageLinkClassName, activeLinkClassName: paginator_styles.activeLinkClassName, breakClassName: paginator_styles.breakClassName, previousLinkClassName: paginator_styles.previousLinkClassName, nextLinkClassName: paginator_styles.nextLinkClassName, disabledClassName: paginator_styles.disabledClassName, renderOnZeroPageCount: functions.noop })));
};

exports.Paginator = Paginator;
//# sourceMappingURL=paginator.js.map
